import { useLanguage, t } from "../../../i18n";
import React from "react";
import { Container, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../../config/routes";
import "./NafathVerification.css";
import Logo from "../../../components/common/Logo/Logo";
export default function NafathVerification() {
  useLanguage();
  const navigate = useNavigate();
  return <div className="bb-nafath-verification-page">
      <Container>
        <div className="bb-nafath-verification-page__Logo">
            <Logo />
        </div>
        <Card className="bb-nafath-verification-card">
          <Card.Body>
            <h1>{t("Nafath Verification")}</h1>
            <p>{t("This screen is the placeholder for the Nafath verification flow. In the next step, we will connect states like pending, success, failed, and retry.")}



            </p>

            <div className="bb-nafath-verification-actions">
              <Button variant="outline-secondary" onClick={() => navigate(ROUTES.HOME)}>{t("Back to Home")}

              </Button>
              <Button className="nafath-verify-simulate__button" onClick={() => alert(t("Dummy Nafath success flow will be connected next."))}>{t("Simulate Verification")}

              </Button>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>;
}
